/// Busca local de listas sem diferenças por caixa, acentos ou espaços nas pontas.
export function matchesListSearch(text: string, search: string): boolean {
  const plain = (value: string) =>
    value
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .toLowerCase();
  return plain(text).includes(plain(search.trim()));
}
